import { Button, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import Title from "antd/lib/typography/Title";
import { useNavigate } from "react-router";

export default function ({ title, backEnabled, level, secondary, extra }) {
  const navigate = useNavigate();
  const l = level ?? 3;
  const be = backEnabled === undefined ? true : backEnabled;
  return (
    <div
      style={{
        display: "flex",
        marginTop: 8,
        marginBottom: 24,
        columnGap: 5,
        alignItems: "start",
      }}
    >
      {be && <Button type={"text"} icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)} />}
      <div style={{ flex: 1 }}>
        <Title level={l} style={{ margin: 0 }}>
          {title}
        </Title>
        <Typography.Text type="secondary">{secondary}</Typography.Text>
      </div>
      <div>{extra}</div>
    </div>
  );
}
